import { Component } from "@angular/core";
import { Calculation } from "@salaxy/core";
import { SalaxyContext } from "../../../services/index";

/** Calculations list implementation based on the repository pattern */
@Component({
    selector: "sxdemo-calculations",
    template: `<h1>Calculation list - repository</h1>
<p>
This implementation uses the repository pattern: The way you would typically implement calculation list.
List of calculations as well as the current calculation is maintained by the CalculationRepository service.
The CalculationRepository service is accessed from SalaxyContext which makes is a singleton:
All the different components will access the same instances of list and current calculation.
</p>
<div class="salaxy-row">
    <div class="scol-4">
        <salaxy-calc-list></salaxy-calc-list>
    </div>
    <div class="scol-8">
        <salaxy-calc-detail></salaxy-calc-detail>
    </div>
</div>
`,
})
export class NgCalculationsComponent {

    /**
     * Default constructor creates a new CalcListComponent
     * @param calcApi - Raw API for the method
     * @param sessionService - Service to check whether the use s authenticated.
     */
    constructor(
        private context: SalaxyContext,
    ) { }

    /** List of calculations */
    public get calculations() {
        return this.context.calculations.list;
    }

    /** Currently selected calculation */
    public get current() {
        return this.context.calculations.current;
    }

    /**
     * Sets the current calculation
     * @param id - Identifier of the calculation
     */
    public setCurrentId(id: string) {
        this.context.calculations.setCurrentId(id);
    }

    /** Creates a new calculation nd sets it as current */
    public createNew() {
        return this.context.calculations.current = this.context.calculations.getBlank();
    }
}
